import { Component, Input } from '@angular/core';
import { addDays, format } from 'date-fns';

@Component({
  selector: 'cigna-password-change-banner-v2',
  templateUrl: './password-change-banner-v2.component.html',
  styleUrl: './password-change-banner-v2.component.scss',
})
export class PasswordChangeBannerV2Component {
  @Input() passwordExpiry: number; // days left until password expires

  isDismissed = false;

  get lockoutDate() {
    return format(addDays(new Date(), this.passwordExpiry), 'MM/dd/yyyy');
  }

  get headerText() {
    return this.passwordExpiry < 0
      ? 'Your password is expired'
      : `Your password expires in ${this.passwordExpiry} days`;
  }

  handleDismiss(event: { detail: { dismissed: boolean } }) {
    this.isDismissed = event.detail.dismissed;
  }
}
